import {
    Component
} from '@angular/core';
import {
    MgFormControlsAccessor,
    MgControlName
  } from "./Login.mg.accessor.g"; 
import {
    TaskBaseMagicComponent,
    magicProviders
} from "@magic-xpa/angular";
import { FormControl, FormGroup } from '@angular/forms'; 
import { variable } from '@angular/compiler/src/output/output_ast';
@Component({
    selector: 'mga-Login',
    providers: [...magicProviders],
    styleUrls: ['./Login.component.css', './reset.css'],
    templateUrl: './Login.component.html'
}) export class Login extends TaskBaseMagicComponent {

    mgNames = MgControlName;
    mgfc: MgFormControlsAccessor;

    createFormControlsAccessor(formGroup: FormGroup) {
      this.mgfc = new MgFormControlsAccessor(formGroup, this.magicServices);
    }
    
    GetValues(USERNAME: any, PASSWORD: any) {
      this.mg.setValueToControl(this.mgNames.Username, USERNAME, true);
      this.mg.setValueToControl(this.mgNames.Password, PASSWORD, true);
      //
      window.alert(USERNAME + " " + PASSWORD);
    } 
}